// timestamp for limiting update impact validity, impacts before this ts are not relevant
export const UPDATE_IMPACTS_SINCE = new Date(Date.UTC(2017, 10)).getTime()

// timestamp for limiting analysis data validity, data for impacts before this ts are not relevant
export const UPDATE_IMPACT_ANALYSIS_DATA_SINCE = new Date(Date.UTC(2017, 1)).getTime()

// Extra calendar days that must elapse on top of the N-day comparison interval
// before an N-day impact aggregate is considered complete. `isVersionTooFresh`
// applies it at calendar-day granularity:
//   tooFresh ⇔ calendarDaysSinceRelease < N + UPDATE_IMPACT_DATA_LAG_DAYS
//
// The Rev/DL pipeline lags ~2 days behind real time (e.g. on May 29 the latest
// available daily data point is May 27). For an N-day post-release aggregate
// to have all N days populated we need
//   latest_data_date >= release_date + (N - 1)        (release-day-inclusive)
//   ⇒ release_date + N <= today - data_lag + 1
//   ⇒ release_date + N + (data_lag - 1) <= today
// With data_lag = 2 that simplifies to a +1 offset, i.e. a version is hidden
// while fewer than (N + 1) calendar days have elapsed since its release.
//
// Hien's GR-2424 boundaries (today = 2026-05-29) confirm this:
//   - 7-day:  release ≤ May 21 visible, May 22 hidden
//   - 14-day: release ≤ May 14 visible, May 15 hidden
//   - 30-day: release ≤ Apr 28 visible, Apr 29 hidden
//
// History: PR #410 set this to 1 with `>=` semantics (over-hid versions with
// full data), PR #447 set it to 0 with `>` semantics (under-hid versions still
// missing the lagged day). The value `1` is correct, but the gate must compare
// CALENDAR DAYS — comparing raw timestamps made the boundary depend on the
// release/now time-of-day and hid boundary versions for part of the day. (GR-2424)
export const UPDATE_IMPACT_DATA_LAG_DAYS = 1
